import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import TournamentDetailsDialog, { formatTournamentDate } from "@/components/TournamentDetailsDialog";
import { ArrowUpRight, Calendar as CalendarIcon, MapPin } from "lucide-react";

export default function AthleteTournaments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/tournaments").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <AppLayout kind="athlete">
      <h1 className="mb-2 text-3xl font-semibold text-white sm:text-4xl">Torneios</h1>
      <p className="mb-8 text-slate-400">Calendário oficial GSX.</p>
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map(t => <TournamentCard key={t.id} tournament={t} />)}
        {!items.length && <div className="text-slate-400">Sem torneios cadastrados.</div>}
      </div>
    </AppLayout>
  );
}

function TournamentCard({ tournament: t }) {
  return (
    <Card className="gsx-card-dark overflow-hidden bg-transparent transition-[border-color,box-shadow,transform] duration-300 hover:border-amber-400/40 hover:shadow-[0_16px_36px_rgba(0,0,0,0.22)] motion-safe:hover:-translate-y-1" data-testid={`athlete-tour-${t.id}`}>
      <TournamentDetailsDialog tournament={t}>
        <button type="button" className="group flex h-full w-full flex-col rounded-xl p-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-amber-400" aria-label={`Ver detalhes de ${t.name}`}>
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-amber-300">
            <CalendarIcon className="h-3 w-3 shrink-0" aria-hidden="true" />
            <span className="font-mono">{formatTournamentDate(t.date)}</span>
            <span aria-hidden="true">•</span>
            <span>{t.time || "A definir"}</span>
          </div>
          <h2 className="mt-2 font-semibold text-white">{t.name}</h2>
          {t.city && <div className="mt-2 flex items-center gap-2 text-xs text-slate-400"><MapPin className="h-3 w-3 shrink-0" aria-hidden="true" />{t.city}</div>}
          {t.info && <p className="mt-3 line-clamp-2 text-xs text-slate-400">{t.info}</p>}
          <span className="mt-auto flex items-center gap-1 pt-4 text-xs font-medium text-amber-300 transition-colors group-hover:text-amber-200">
            Ver detalhes <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
        </button>
      </TournamentDetailsDialog>
    </Card>
  );
}
